module.exports = __webpack_public_path__ + "img/he4.3f1b7eff.png";